/**
 * Every string the Users list's access tabs, row menu and Remove / Restore
 * Access modals show (PD-4677), gathered the way the Access & Permissions tab
 * gathers its own so the wording can be reviewed without reading the
 * components.
 */

export const ACCESS_TABS = {
  current: 'Current Access',
  removed: 'Removed Access',
};

export const ROW_ACTIONS = {
  toggle: (name) => `Actions for ${name}`,
  viewDetails: 'View Details',
  remove: 'Remove Access',
  restore: 'Restore Access',
};

export const REMOVED_COLUMN = 'Removed';

/**
 * The design's sentences name a REMOVE ACCESS / RESTORE ACCESS button, but its
 * footer buttons read REMOVE USER and ADD USER (Figma 1301:21874, 1301:21726).
 * The buttons are named after the sentence instead: a dialog that tells you to
 * click something not on screen is the worse half of the contradiction, and
 * "Add User" is a different action altogether, already taken by the Create User
 * wizard. Raised on the ticket.
 */
export const ACCESS_MODAL = {
  remove: {
    title: 'Remove Access',
    description:
      'Clicking REMOVE ACCESS will prevent this user from accessing the selected accounts.',
    submit: 'Remove Access',
    submitting: 'Removing...',
    accountLabel: 'Account',
    accountHelp: 'Choose one or multiple accounts from the list.',
    accountEmpty: 'This user has no accounts to remove.',
    failedTitle: 'Access not removed.',
    toast: (name) => `${name} no longer has access to the selected accounts.`,
    toastTitle: 'Access removed successfully',
  },
  restore: {
    title: 'Restore Access',
    description:
      'Clicking RESTORE ACCESS will again grant this user access to the selected accounts with previous permissions.',
    submit: 'Restore Access',
    submitting: 'Restoring...',
    accountLabel: 'Account',
    accountHelp: 'Choose one or multiple accounts from the list.',
    accountEmpty: 'This user has no removed accounts to restore.',
    failedTitle: 'Access not restored.',
    toast: (name) => `${name} again has access to the selected accounts.`,
    toastTitle: 'Access restored successfully',
  },
  cancel: 'Cancel',
  loading: 'Loading accounts...',
  // Reached when every account came back rejected, or when the list the modal
  // opened on has gone stale under it.
  generic: 'Something went wrong. Please try again.',
};

// The design puts a Team select above the Account picker (Figma 1301:21872).
// Not built: teams do not exist yet (PD-4213) and the field is marked required,
// so it would open with nothing to choose and no way to satisfy it. Raised on
// the ticket.
export const TEAM_FIELD_PENDING = 'PD-4213';
